module.exports = __webpack_public_path__ + "img/verifydefault.6b914f9c.jpg";